/**
 * 客户端路由切换后的 document.title / meta description 同步
 *
 * 构建期 build/prerender-postprocess.js 已经按路由写好了独立 title 与 description，
 * 但那是写进静态 HTML 的一次性值：SPA 内部跳转不会重新加载文档，
 * 标题和描述会一直停在首次进入的那个页面，用户收藏、分享、看标签页拿到的都是错的。
 *
 * 文案与规则都来自构建期同一份（src/seo/pages-meta.json + src/seo/meta-rules.js），
 * 这里只负责把算出来的值写进 DOM，不再自己拼标题——两套规则是上次标题对不上的根因。
 */

import RULES from '../seo/meta-rules'

function readBrandFlag() {
  try {
    var cfg = window['pathConfig'][process.env.NODE_ENV]
    return !!(cfg && cfg.isxunjee)
  } catch (e) {
    return true
  }
}

/** 取当前页面渲染出的 h1，详情页的真实名称通常就在里面 */
function h1Text() {
  var el = document.querySelector('#app h1')
  if (!el) return ''
  return (el.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 40)
}

/** 没有就建一个，预渲染页面上已经存在则直接改 content */
function setMetaDescription(text) {
  if (!text) return
  var el = document.querySelector('meta[name="description"]')
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute('name', 'description')
    document.head.appendChild(el)
  }
  el.setAttribute('content', text)
}

function apply(route, allowDetail) {
  var path = route.path || '/'
  var segs = path.split('/').filter(Boolean)
  var isxj = readBrandFlag()
  var detailName = allowDetail && segs.length > 1 ? h1Text() : ''

  var meta = RULES.resolveMeta(path, isxj, detailName)
  document.title = meta.title
  setMetaDescription(meta.description)
}

var timer = null

/**
 * 路由切换后更新标题与描述
 * @param {Object} route vue-router 的 to 对象
 */
export function applyPageTitle(route) {
  if (!route || !route.path) return

  // 先按栏目文案立即写一次，保证标题一定是当前页面的
  apply(route, false)

  // 详情页的真实名称在接口返回后才出现，稍后再补一次。
  // 只保留最后一次路由的定时器，避免快速连续点击时新旧页面互相覆盖
  clearTimeout(timer)
  timer = setTimeout(function () {
    apply(route, true)
  }, 700)
}
